package com.example.mystybag.sharedmodels.project.requestModels.reservations

import com.example.mystybag.sharedmodels.AllCommands.CREATE_RESERVATION
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
class CreateReservationRequestModel(
    val userId                  : Long = 0L,
    val bagId                   : Long = 0L,
    val bagsCount               : Int = 1
) : BaseRequestModel(api = CREATE_RESERVATION)